import { Link } from '@cian/ui-kit';

import { type FC, type MouseEvent, useCallback } from 'react';

import { useCardOfferDataContext } from '../../../context/selectors';

export const ParentContainer: FC = () => {
  const { parentCard } = useCardOfferDataContext();

  const handleClick = useCallback((e: MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation();
  }, []);

  if (!parentCard) {
    return null;
  }

  const { name, url } = parentCard;

  return (
    <span data-testid="card.parent-card.name">
      <Link fontSize="S" href={url} inline={true} target="_blank" onClick={handleClick}>
        {name}
      </Link>
    </span>
  );
};
